import { Card, CardHeader } from "@/components/Card";
import { Chip } from "@/components/Chip";
import type { FolioPrincipal } from "@/lib/types";

export function InmuebleCard({ data }: { data: FolioPrincipal }) {
  return (
    <Card>
      <CardHeader
        title="Inmueble"
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            aria-hidden
          >
            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
        }
      />

      <p className="mt-3 text-base font-medium leading-relaxed text-slate-900">
        {data.domicilio}
      </p>

      <div className="mt-4 flex flex-wrap gap-2">
        <Chip tone="indigo">{data.usoSuelo}</Chip>
        <Chip tone="slate">Superficie {data.superficie}</Chip>
        {data.cp && data.cp !== "0" && <Chip tone="slate">CP {data.cp}</Chip>}
      </div>

      <dl className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3 border-t border-slate-100 pt-4 text-sm">
        <Field label="Estado" value={data.estado} />
        <Field label="Municipio" value={data.municipio} />
        <Field label="Lote" value={data.lote} />
        <Field label="Manzana" value={data.manzana} />
      </dl>

      <details className="group mt-4 rounded-xl bg-slate-50 p-4">
        <summary className="flex cursor-pointer list-none items-center justify-between text-sm font-medium text-slate-700">
          <span className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-4 w-4 text-slate-500"
              aria-hidden
            >
              <path d="M12 22s-8-4.5-8-11.8a8 8 0 1 1 16 0c0 7.3-8 11.8-8 11.8" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            Medidas y colindancias
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4 text-slate-400 transition group-open:rotate-180"
            aria-hidden
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </summary>
        <p className="mt-3 text-sm leading-relaxed text-slate-700">
          {data.medidasColindancias}
        </p>
      </details>
    </Card>
  );
}

function Field({ label, value }: { label: string; value: string | null }) {
  return (
    <div>
      <dt className="text-xs font-medium uppercase tracking-wider text-slate-500">
        {label}
      </dt>
      <dd className="mt-0.5 text-sm font-medium text-slate-800">
        {value && value.length > 0 ? value : "—"}
      </dd>
    </div>
  );
}
